import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import Layout from "layouts/LayoutMasterDetail";
import TransferPersonelServiceItem from "./TransferPersonelServiceItem";
import ServiceMetricCell from "features/services/shared/ServiceMetricCell";
import { getServiceRouteTimeColumns } from "features/services/shared/serviceRouteTimeColumns";
import { StoreContext } from "shared/context/store-context";
import { personelServiceRouteTypes_tr, personelServiceRouteTypes_en } from "shared/util/types";
import { getCurrentLanguage } from "shared/utility/lang";
import CreatePersonelRoutesAutomation from "components/shared/automations/CreatePersonelRoutesAutomation";
import { SERVICE_TYPES } from "@routebot/constants";
import { noPersonelSchoolBlocker } from "shared/utility/blocker-conditions";

const StandardPersonelServices = ({ isNewItem }) => {
  const { t } = useTranslation();
  const itemType = "standartpersonelservice";
  const listName = "main_transferpersonelservices";

  const currentLanguage = getCurrentLanguage();

  const personelServiceRouteTypes =
    currentLanguage === "tr" ? personelServiceRouteTypes_tr : personelServiceRouteTypes_en;

  const {
    standartPersonelServices,
    schoolOptions,
    driverOptions,
    schools,
    InsertPersonelService,
    DeletePersonelService,
    UpdatePersonelService,
  } = useContext(StoreContext);

  const pageItems = standartPersonelServices.filter((item) => item.serviceType === SERVICE_TYPES.TRANSFER_PERSONEL);

  const listColumns = [
    {
      field: "school",
      headerName: t("client"),
      width: 250,
      valueGetter: (params) =>
        schoolOptions.find((item) => item?.value?.toString() === params?.row?.school?.id?.toString())?.label,
    },

    { field: "date", headerName: t("date"), width: 150 },

    { field: "name", headerName: t("name"), width: 400 },
    {
      field: "type",
      headerName: t("serviceType"),
      width: 130,
      valueGetter: (params) =>
        personelServiceRouteTypes.find((item) => item?.value?.toString() === params.row.routeType.toString())?.label,
    },
    {
      field: "drivers",
      headerName: t("driver"),
      width: 300,
      valueGetter: (params) => {
        try {
          return driverOptions.find((item) => item.value.toString() === params?.row?.drivers[0]?.id.toString()).label;
        } catch (e) {
          return "";
        }
      },
    },
    { field: "plate", headerName: t("plate"), width: 150 },
    {
      field: "numOfPassengers",
      headerName: t("numberofpassengers"),
      width: 100,
      valueGetter: (params) => params.row?.users?.length?.toString() || "-",
    },
    ...getServiceRouteTimeColumns(t),
    // Rota metriği (mesafe/süre). Eksikse listede kırmızı "Hesaplanmadı" rozeti gösterilir.
    {
      field: "routeMetrics",
      headerName: t("routeMetrics"),
      width: 200,
      valueGetter: (params) => {
        const duration = Number(params.row?.totalDuration);
        return Number.isFinite(duration) ? duration : 0;
      },
      renderCell: (params) => <ServiceMetricCell row={params.row} />,
    },
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={TransferPersonelServiceItem}
      NewItemComponent={TransferPersonelServiceItem}
      DeleteItem={DeletePersonelService}
      InsertItem={InsertPersonelService}
      UpdateItem={UpdatePersonelService}
      isAlwaysFullScreen={true}
      hideCreateNewItem={true}
      hideCreateNewItemWhenSelected={true}
      isNewItem={isNewItem}
      BulkProcessComponent={CreatePersonelRoutesAutomation}
      blockerConditions={[noPersonelSchoolBlocker(schools)]}
    />
  );
};

export default StandardPersonelServices;
